<template>
  <div class=" is-fullwidth">
    <div>
      <div class="is-pulled-left">
        <div class="buttons">
          <button class="button " :class="{'is-info': scheduler_type == 'artwork'}" @click="scheduler_type='artwork'">Artwork</button>
          <button class="button " :class="{'is-info': scheduler_type == 'printing'}" @click="scheduler_type='printing'">Printing Strabane</button>
          <button class="button " :class="{'is-info': scheduler_type == 'cutting'}" @click="scheduler_type='cutting'">Cutting Strabane</button>
        </div>
      </div>

      <div class="is-pulled-left">
        <table class="table is-hoverable is-bordered ml-2 " id="overviewtable" >
              <tbody>
                <tr>
                  <td class="">Orders</td>
                  <td>{{ filteredOrders.length }}</td>
                  <td class="">Garments</td>
                  <td>{{ total_qty }}</td>
                
                  </tr>
              </tbody>
            </table>
      </div>
    
      <div class="is-pulled-right">
        
          <input class="input" v-model="search" placeholder="search orders ..."/>
          
      </div>
     <div class="is-pulled-right"><input class="input" type="date" v-model="end_date" /></div>
     <div class="is-pulled-right"><input class="input" type="date" v-model="start_date" /></div>
     <div class="is-pulled-right">

      <select class="input" v-model="range_id">
        <option value="">Garment Type</option>
        <option value="1">Jerseys</option>
        <option value="2">Leisurewear</option>
        <option value="3">Shorts</option>
        <option value="4">Accessories</option>
      </select>
     </div>
    </div>

    <div class="row" v-if="scheduler_type == 'artwork'" style="clear:both">
      <div class="buttons has-addons ">
          <button class="button is-small  mr-2" :class="{'is-success': artwork_print_location_id == row.id}" v-for="row in locations" :key="row.id" @click="artwork_print_location_id=row.id">{{ row.name }}</button>
          <button class="button is-small  mr-2" :class="{'is-success': artwork_print_location_id == 'undefined'}"  @click="artwork_print_location_id='undefined'">All Locations</button>
        </div>
    </div>

   <div style="clear:both">
    <br />
<p v-if="1==2 && scheduler_type == 'cutting'">If an order is showing on this page, it has NOT yet been processed for Makeup. Please go to the Awaiting Makeup screen to do this.</p>
</div>
    <em>These tables may not be accurate due to a recent change to Print Location. They are being updated currently.</em>
    <div v-if="view=='split'">
        <SchedulerOrdersTable :orders="this.ordersLessThan5" :loading="this.loading" label="Orders With Less Than Or 5 Garments" :locations="this.locations" table_name="lessthan5"/>

        <SchedulerOrdersTable :orders="this.ordersMoreThan5ROI" :loading="this.loading" label="Orders With More Than 5 Garments For ROI Customers " :locations="this.locations" table_name="morethan5roi"/>

        <SchedulerOrdersTable :orders="this.ordersMoreThan5Other" :loading="this.loading" label="Orders With More Than 5 Garments For Other Customers " :locations="this.locations" table_name="morethan5other"/>
    </div>
    <div v-else>
        <SchedulerOrdersTable :orders="this.filteredOrders" :loading="this.loading" label="All Orders " :locations="this.locations" table_name="allorders"/>
    </div>
    <button @click="switchView()" class="button is-info is-pulled-right" >Switch View</button>
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

//import OrderModal from '@/components/OrderModal';
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import UserService from '@/services/UserService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

import SchedulerOrdersTable from '@/components/DigitalPrint/SchedulerOrdersTable';

export default {
  components: {
    SchedulerOrdersTable
  },
   mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      locations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      quality_users: [],
      search: '',
      order_by: 'deliverydate ASC',
      user: [],
      start_date: '',
      end_date: '',
      scheduler_type: '',
      print_location_id: 1, // Strabane only for now
      artwork_print_location_id: 'undefined', 
      range_id:'',
      accessToken: '',
      view: ''
      
    }
  },
   methods: {
      
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getDigitalPrintScheduler(this.accessToken, "", this.order_by, this.start_date, this.end_date, this.scheduler_type, this.print_location_id, this.range_id, this.artwork_print_location_id)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async getUser(id) {
        //this.loading=true
        UserService.getUser(this.accessToken, id)
        .then(
          (user => {
            this.$set(this, "user", user);
            //this.loading=false
          }).bind(this)
        );
      },
      async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1").then(
               response => this.locations = response 
            );
      },
      showLocationName(print_location_id) {
        const result = this.locations.filter(location => location.id == print_location_id)
        if(result.length > 0)
        {
          return result[0].name
        }
        else{
          return ""
        }
      },
      switchView() {
        if(this.view == '')
        {
            this.view = 'split'
        }
        else{
            this.view = ''
        }
      },
    
      exportXLS() {

        var wb = XLSX.utils.book_new();
        wb.SheetNames.push("Orders");
        var ws1 = XLSX.utils.table_to_sheet(document.getElementById('orderstable-excel')); // Removed , {raw:true}
        wb.Sheets["Orders"] = ws1;
      
        XLSX.writeFile(wb, 'Scheduler.xlsx');
      
    },
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
    },

    
    
  },
  computed : {
     filteredOrders: function () {
       
        let filteredOrders =  this.orders

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     ordersLessThan5: function () {
       
       let ordersLessThan5 =  this.orders

         if(this.search != '' && this.search != null)
         {
            ordersLessThan5 = ordersLessThan5.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
         }

         ordersLessThan5 = ordersLessThan5.filter(row => row.total_qty <= 5)

         return ordersLessThan5
         
    },
    ordersMoreThan5ROI: function () {
       
       let ordersMoreThan5ROI =  this.orders

         if(this.search != '' && this.search != null)
         {
            ordersMoreThan5ROI = ordersMoreThan5ROI.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
         }

         ordersMoreThan5ROI = ordersMoreThan5ROI.filter(row => row.total_qty > 5)
         ordersMoreThan5ROI = ordersMoreThan5ROI.filter(row => (row.clientLocationID == 1 && (row.clientname != "Retail County Leisurewear" && row.clientname != "SPORTS DIRECT - REPLICAS" && row.clientname != "ELVERYS REPLICAS - PAT DARGAN")))

         

         return ordersMoreThan5ROI
         
    },
    ordersMoreThan5Other: function () {
       
       let ordersMoreThan5Other =  this.orders

         if(this.search != '' && this.search != null)
         {
            ordersMoreThan5Other = ordersMoreThan5Other.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
         }

         ordersMoreThan5Other = ordersMoreThan5Other.filter(row => row.total_qty > 5)
         ordersMoreThan5Other = ordersMoreThan5Other.filter(row => (row.clientLocationID > 1 || row.clientname == "Retail County Leisurewear" || row.clientname == "SPORTS DIRECT - REPLICAS" || row.clientname == "ELVERYS REPLICAS - PAT DARGAN"))

         return ordersMoreThan5Other
         
    },
     artworkManager: function() {
       return this.$auth.user.roles.includes("Artwork Manager")
       
     },
     artworkQualityUser: function() {
       return this.$auth.user.roles.includes("Artwork Quality") || this.user.artworker_quality == true
       
     },
     total_qty: function() {
        return this.filteredOrders.reduce((total, item) => total + item.total_qty, 0);
      },

      base_route: function() {
        
        let base_route = '/digitalprint'
        if(this.$route.path.includes('printing-cutting') == true)
        {
          base_route =  '/printing-cutting'
        }
        
        
        return base_route
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
            this.getUser("self");

        });
  },
 
  mounted() {
    if (localStorage.scheduler_start_date) {
      this.start_date = localStorage.scheduler_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

     if (localStorage.scheduler_end_date) {
      this.end_date = localStorage.scheduler_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }

    if (localStorage.scheduler_type) {
      this.scheduler_type = localStorage.scheduler_type;
    }
    else{
      this.scheduler_type = 'artwork'
    }

    if (localStorage.range_id) {
      this.range_id = localStorage.range_id;
    }
    else{
      this.range_id = ''
    }

    if (localStorage.artwork_print_location_id) {
      this.artwork_print_location_id = localStorage.artwork_print_location_id;
    }
    else{
      this.artwork_print_location_id = 'undefined'
    }
      
  },
  watch: {
    start_date: function () {
     localStorage.scheduler_start_date = this.start_date;
      if(this.accessToken != '')
        {
          this.orders = []
          this.getOrders();
        }
    },
    end_date: function () {
     localStorage.scheduler_end_date = this.end_date;
      if(this.accessToken != '')
        {
          this.orders = []
          this.getOrders();
        }
    },
    scheduler_type: function () {
     localStorage.scheduler_type = this.scheduler_type;
     if(this.accessToken != '')
      {
        this.orders = []
        this.getOrders();
      } 
    },
    range_id: function () {
     localStorage.range_id = this.range_id;
     if(this.accessToken != '')
      {
        this.orders = []
        this.getOrders();
      }
    },
    artwork_print_location_id: function () {
     localStorage.artwork_print_location_id = this.artwork_print_location_id;
     if(this.accessToken != '')
      {
        this.orders = []
        this.getOrders();
      }
    },
  }
}


</script>

